'use client'
import type { ComponentType, RefObject } from 'react'

import { tw } from '@/lib/utils'
import type { NavContainerConfig } from '@/types/nav-types'

import type { LauncherResultsProps } from './launcher-results'
import { LauncherSearch } from './launcher-search'
import { LauncherSection } from './launcher-section'
import styles from './launcher-styles'
import type { LauncherQuery } from './launcher-types'

export interface LauncherPanelProps {
  container: NavContainerConfig
  query: LauncherQuery
  inputRef: RefObject<HTMLInputElement | null>
  Results: ComponentType<LauncherResultsProps> | null
}

// Categories and search ship with the panel; only its rich results are deferred.
// Keep these controls mounted when the results arrive so focus and tree state stay.
export const LauncherPanel = (props: LauncherPanelProps) => (
  <div
    className={tw(
      'mx-auto flex min-h-0 w-[1440px] max-w-full flex-1 flex-col px-12 pt-4 pb-6 desktop-xl:w-[1920px] desktop-xl:px-16',
      styles.content
    )}
  >
    {props.container.type === 'search' ? <LauncherSearch {...props} /> : <LauncherSection {...props} />}
  </div>
)
